import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  QueryList,
  SimpleChanges,
  ViewChildren,
} from '@angular/core';
import { FormArray, FormGroup, ReactiveFormsModule } from '@angular/forms';
import {
  CheckboxComponent,
  MotifButtonModule,
  MotifFormsModule,
  MotifIconModule,
} from '@ey-xd/ng-motif';
import {
  SurveyQuestion,
  SurveyQuestionType,
  SurveyTextType,
} from 'app/models/feedback-question';

@Component({
  selector: 'app-feedback-question',
  standalone: true,
  imports: [
    CommonModule,
    MotifIconModule,
    ReactiveFormsModule,
    MotifFormsModule,
    MotifButtonModule,
  ],
  templateUrl: './feedback-question.component.html',
  styleUrl: './feedback-question.component.scss',
})
export class FeedbackQuestionComponent implements OnChanges {
  @Input() question?: SurveyQuestion;
  @Input() formGroup?: FormGroup;

  @ViewChildren('optionContainer') optionContainers?: QueryList<ElementRef>;

  @ViewChildren('optionCheckbox')
  optionCheckboxes?: QueryList<CheckboxComponent>;

  FeedbackQuestionType = SurveyQuestionType;
  FeedbackTextType = SurveyTextType;

  private _optionFormGroups?: FormGroup[];
  get optionFormGroups(): FormGroup[] | undefined {
    if (!this.formGroup) {
      return undefined;
    }

    if (!this._optionFormGroups) {
      this._optionFormGroups = (this.formGroup.get('options') as FormArray)
        .controls as FormGroup[];
    }

    return this._optionFormGroups;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['question']) {
      setTimeout(() => {
        this.updateCheckboxesColors();
      }, 1);
    }
  }

  private updateCheckboxesColors(): void {
    if (!this.question?.options) {
      return;
    }

    if (!this.optionContainers) {
      setTimeout(() => {
        this.updateCheckboxesColors();
      }, 10);
      return;
    }

    this.optionContainers.forEach((container, index) => {
      const option = this.question!.options![index];
      if (option) {
        container.nativeElement.style.setProperty(
          '--label-color',
          option.label_color || '#000000'
        );
      }
    });
  }

  onOptionCheckboxChange(
    changedCheckboxIndex: number,
    isChecked: boolean
  ): void {
    if (!this.optionCheckboxes) {
      setTimeout(() => {
        this.onOptionCheckboxChange(changedCheckboxIndex, isChecked);
      }, 10);
      return;
    }

    // const checkboxes = this.optionCheckboxes.toArray();
    // const changedCheckbox = checkboxes[changedCheckboxIndex];

    // for (const checkbox of this.optionCheckboxes) {
    //   if (checkbox !== changedCheckbox) {
    //     checkbox.checked = false;
    //   }
    // }

    this.optionFormGroups?.forEach((formGroup, index) => {
      if (index != changedCheckboxIndex) {
        formGroup.get('optionChecked')?.setValue(false);
        formGroup.get('textInput')?.setValue('');
      }
    });
  }
}
